// utils/appointmentHelpers.ts
import { AppointmentDetail, AppointmentStatus } from '../types/appointment';

// Iconos por estado (FontAwesome)
export const getStatusIcon = (status: AppointmentStatus): string => {
  switch (status) {
    case AppointmentStatus.UPCOMING: return 'far fa-calendar';
    case AppointmentStatus.SCHEDULED: return 'far fa-clock';
    case AppointmentStatus.LATE: return 'fas fa-exclamation-triangle';
    case AppointmentStatus.MISSED: return 'fas fa-times-circle';
    case AppointmentStatus.IN_PROGRESS: return 'fas fa-user-check';
    case AppointmentStatus.COMPLETED: return 'fas fa-check-circle';
    default: return 'far fa-calendar';
  }
};

// Colores Bootstrap por estado
export const getStatusColor = (status: AppointmentStatus): string => {
  switch (status) {
    case AppointmentStatus.UPCOMING: return 'primary';
    case AppointmentStatus.SCHEDULED: return 'info';
    case AppointmentStatus.LATE: return 'warning';
    case AppointmentStatus.MISSED: return 'danger';
    case AppointmentStatus.IN_PROGRESS: return 'success';
    case AppointmentStatus.COMPLETED: return 'secondary';
    default: return 'light';
  }
};

// Texto descriptivo en español
export const getStatusText = (status: AppointmentStatus): string => {
  switch (status) {
    case AppointmentStatus.UPCOMING: return 'Próxima';
    case AppointmentStatus.SCHEDULED: return 'En tiempo';
    case AppointmentStatus.LATE: return 'Atrasada';
    case AppointmentStatus.MISSED: return 'No asistió';
    case AppointmentStatus.IN_PROGRESS: return 'En instalaciones';
    case AppointmentStatus.COMPLETED: return 'Finalizada';
    default: return 'Desconocido';
  }
};

// Determinar si se puede hacer check-in
export const canCheckIn = (appointment: AppointmentDetail): boolean => {
  return appointment.current_status === AppointmentStatus.UPCOMING || 
         appointment.current_status === AppointmentStatus.SCHEDULED || 
         appointment.current_status === AppointmentStatus.LATE;
};

// Determinar si se puede hacer check-out
export const canCheckOut = (appointment: AppointmentDetail): boolean => {
  return appointment.current_status === AppointmentStatus.IN_PROGRESS;
};

// Tiempo restante legible
export const getTimeRemainingText = (appointment: AppointmentDetail): string => {
  if (appointment.current_status === AppointmentStatus.COMPLETED) return 'Finalizada';
  if (appointment.current_status === AppointmentStatus.MISSED) return 'No asistió';
  
  if (appointment.minutes_remaining > 0) {
    const hours = Math.floor(appointment.minutes_remaining / 60);
    const minutes = appointment.minutes_remaining % 60;
    
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes} min`;
  }
  
  if (appointment.minutes_remaining === 0) return 'Tiempo agotado';
  return '';
};

// Estado de tiempo (para mostrar en badge)
export const getTimeStatus = (appointment: AppointmentDetail): string => {
  if (appointment.current_status === AppointmentStatus.LATE) {
    return `Atrasada ${appointment.minutes_since_start} min`;
  }
  
  if (appointment.current_status === AppointmentStatus.UPCOMING && appointment.minutes_until_start > 0) {
    if (appointment.minutes_until_start > 60) {
      const hours = Math.floor(appointment.minutes_until_start / 60);
      return `En ${hours} h`;
    }
    return `En ${appointment.minutes_until_start} min`;
  }
  
  if (appointment.is_within_time_window) {
    return `Quedan ${appointment.minutes_remaining} min`;
  }
  
  return getStatusText(appointment.current_status);
};